<template src="../templates/normal_fcont_86.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import CreativePrint from '../components/CreativePrint'

import { Carousel,Slide } from 'uiv'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
import CreatorProfileItsuka from "../components/CreatorProfileItsuka"
import AppDownloadCreative from '../components/AppDownloadCreative'
import AppDownloadiPrint from '../components/AppDownloadiPrint';
export default {
  name: 'app',
  components: {
   LabelFunMessage,FuncSearchRecommendLink,Carousel,Slide,FuncSearchGalleryQR,CreativePrint,
   CreatorProfileItsuka,AppDownloadCreative,AppDownloadiPrint
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    }
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['86-1'],
    meta: [
      { name: 'description', content: this.$store.state.messages.messages['86-2']}
    ]};
  }
};
</script>
<style />


